module.exports = __webpack_public_path__ + "static/hdw-59c63a6830273c505f22cb2e51e09e73.svg";